import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { PurchaseReport } from '@app/feature/dealer/report/purchase-report';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var ListReportsService = /** @class */ (function () {
    function ListReportsService(http) {
        this.http = http;
    }
    ListReportsService.prototype.readReportsList = function (purchaseDate, fisherId, dealerId) {
        // const purchaseDateParam: string = purchaseDate.getFullYear().toString() + purchaseDate.getMonth().toString() + purchaseDate.getDate().toString();
        var url = "dealers/" + (dealerId ? dealerId : 'me') + "/reports/?purchaseDate=" + purchaseDate + "&fisherId=" + fisherId;
        return this.http
            .get(url, {
            headers: { 'Content-Type': 'application/json' }
        })
            .pipe(map(function (response) { return response ? response.map(function (element) { return PurchaseReport.fromJSON(element); }) : null; }));
    };
    ListReportsService.ngInjectableDef = i0.defineInjectable({ factory: function ListReportsService_Factory() { return new ListReportsService(i0.inject(i1.HttpClient)); }, token: ListReportsService, providedIn: "root" });
    return ListReportsService;
}());
export { ListReportsService };
